/**
 * ORDER_MONEY_PAY_TYPE 订单支付状态 1全款支付  2支付定金 3 支付尾款
 */
export const ORDER_MONEY_PAY_TYPE = {
  /**
   * 全款支付
   */
  commonGood: 1,
  /**
   * 支付定金
   */
  prePayOrder: 2,
  /**
   * 支付尾款
   */
  endPayOrder: 3,

  /**
   * 定金尾款支付完成
   */
  stepOrderFinished: 4
}

/**
 * 是否为定金尾款单 0 否 1 是
 */
export const ORDER_STATUS = {
  /**
   * 全款单
   */
  wholeOrder: 0,
  /**
   * 尾款单
   */
  stepOrder: 1
}

/**
 * 分段母子订单类型
 * 0 全款单  10定金尾款的母订单 20 定金尾款的定金单 25 定金尾款的尾款单 30云摄影补充子订单
 */
export const ORDER_TYPE_FOR_PERIOD = {
  /**
   * 全款单
   */
  WHOLE_PAID_ORDER: 0,
  /**
   * 定金尾款的母订单
   */
  MONEY_PEROID_MODE_1_MAIN_ORDER: 10,
  /**
   * 定金尾款的定金单
   */
  MONEY_PEROID_MODE_1_1_PRE_PAY_ORDER: 20,
  /**
   * 定金尾款的尾款单
   */
  MONEY_PEROID_MODE_1_2_END_PAY_ORDER: 25,
  /**
   * 云摄影补充子订单
   */
  CLOUD_PHOTO_APPEND_CHILD_ORDER: 30
}
